import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"

export default function Carsused() {
  return (
    <Layout>

      <div class="container">
      <div class="row mx-lg-n5 mt-3">
            <h5>All Used Car Makes</h5>
        </div>
        
        <div class="row mx-lg-n5 mt-3">
          <div class="col-md-2"><Link to="/carsused?make=alfa">Alfa Romeo</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=alpine">Alpine</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=aston">Aston Martin</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=audi">Audi</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=bentley">Bentley</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=bmw">BMW</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=byd">BYD</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=citroen">Citroen</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=ds">DS</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=ferrari">Ferrari</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=fiat">Fiat</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=ford">Ford</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=golden">Golden Dragon</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=hino">Hino</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=honda">Honda</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=hyundai">Hyundai</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=infiniti">Infiniti</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=land">Land Rover</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=lexus">Lexus</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=lotus">Lotus</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=maserati">Maserati</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=maxus">Maxus</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=mazda">Mazda</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=mclaren">McLaren</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=mercedes">Mercedes-Benz</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=mg">MG</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=mini">Mini</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=mitsubishi">Mitsubishi</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=nissan">Nissan</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=opel">Opel</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=perodua">Perodua</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=peugeot">Peugeot</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=porsche">Porsche</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=renault">Renault</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=rolls">Rolls-Royce</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=seat">SEAT</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=skoda">Skoda</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=ssangyong">Ssangyong</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=subaru">Subaru</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=suzuki">Suzuki</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=tesla">Tesla</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=toyota">Toyota</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=volkswagen">Volkswagen</Link></div>
          <div class="col-md-2"><Link to="/carsused?make=volvo">Volvo</Link></div>
        </div>

        <div class="row mx-lg-n5 mt-5">
            <h5>Latest Used Cars</h5>
        </div>

        <div class="row mx-lg-n5">
            <div class="col-md-4 p-2">
                <div class="card">
                    <img src="/main/20201015_carimage_12.jpg" class="card-img-top" alt="20201015_carimage_12" />
                    <div class="card-body">
                    <h5 class="card-title">Skoda Octavia</h5>
                    <p class="card-text">With its compact dimensions, state-of-the-art driver-assistance systems, perfect for city traffic and long hauls alike.</p>
                    <Link to="/carsusedprice" class="btn btn-danger btn-block">Available Prices</Link>
                    </div>
                </div>
            </div>
            <div class="col-md-4 p-2">
                <div class="card">
                    <img src="/main/20201015_carimage_13.jpg" class="card-img-top" alt="20201015_carimage_13" />
                    <div class="card-body">
                    <h5 class="card-title">Audi A6</h5>
                    <p class="card-text">The Audi A6 is elegant and sporty in design with combination of cutting-edge technology and unmistakable sophistication.</p>
                    <Link to="/carsusedprice" class="btn btn-danger btn-block">Available Prices</Link>
                    </div>
                </div>
            </div>
            <div class="col-md-4 p-2">
                <div class="card">
                    <img src="/main/20201015_carimage_14.jpg" class="card-img-top" alt="20201015_carimage_14" />
                    <div class="card-body">
                    <h5 class="card-title">Audi Q5</h5>
                    <p class="card-text">Expressive appearance, powerful drive, and pioneering technology. Your options are just as diverse.</p>
                    <Link to="/carsusedprice" class="btn btn-danger btn-block">Available Prices</Link>
                </div>
              </div>
            </div>
            <div class="col-md-4 p-2">
                <div class="card">
                    <img src="/main/20201015_carimage_12.jpg" class="card-img-top" alt="20201015_carimage_12" />
                    <div class="card-body">
                    <h5 class="card-title">Skoda Octavia</h5>
                    <p class="card-text">With its compact dimensions, state-of-the-art driver-assistance systems, perfect for city traffic and long hauls alike.</p>
                    <Link to="/carsusedprice" class="btn btn-danger btn-block">Available Prices</Link>
                    </div>
                </div>
            </div>
            <div class="col-md-4 p-2">
                <div class="card">
                    <img src="/main/20201015_carimage_13.jpg" class="card-img-top" alt="20201015_carimage_13" />
                    <div class="card-body">
                    <h5 class="card-title">Audi A6</h5>
                    <p class="card-text">The Audi A6 is elegant and sporty in design with combination of cutting-edge technology and unmistakable sophistication.</p>
                    <Link to="/carsusedprice" class="btn btn-danger btn-block">Available Prices</Link>
                    </div>
                </div>
            </div>
            <div class="col-md-4 p-2">
                <div class="card">
                    <img src="/main/20201015_carimage_14.jpg" class="card-img-top" alt="20201015_carimage_14" />
                    <div class="card-body">
                    <h5 class="card-title">Audi Q5</h5>
                    <p class="card-text">Expressive appearance, powerful drive, and pioneering technology. Your options are just as diverse.</p>
                    <Link to="/carsusedprice" class="btn btn-danger btn-block">Available Prices</Link>
                </div>
              </div>
            </div>
            <div class="col-md-4 p-2">
                <div class="card">
                    <img src="/main/20201015_carimage_12.jpg" class="card-img-top" alt="20201015_carimage_12" />
                    <div class="card-body">
                    <h5 class="card-title">Skoda Octavia</h5>
                    <p class="card-text">With its compact dimensions, state-of-the-art driver-assistance systems, perfect for city traffic and long hauls alike.</p>
                    <Link to="/carsusedprice" class="btn btn-danger btn-block">Available Prices</Link>
                    </div>
                </div>
            </div>
            <div class="col-md-4 p-2">
                <div class="card">
                    <img src="/main/20201015_carimage_13.jpg" class="card-img-top" alt="20201015_carimage_13" />
                    <div class="card-body">
                    <h5 class="card-title">Audi A6</h5>
                    <p class="card-text">The Audi A6 is elegant and sporty in design with combination of cutting-edge technology and unmistakable sophistication.</p>
                    <Link to="/carsusedprice" class="btn btn-danger btn-block">Available Prices</Link>
                    </div>
                </div>
            </div>
            <div class="col-md-4 p-2">
                <div class="card">
                    <img src="/main/20201015_carimage_14.jpg" class="card-img-top" alt="20201015_carimage_14" />
                    <div class="card-body">
                    <h5 class="card-title">Audi Q5</h5>
                    <p class="card-text">Expressive appearance, powerful drive, and pioneering technology. Your options are just as diverse.</p>
                    <Link to="/carsusedprice" class="btn btn-danger btn-block">Available Prices</Link>
                </div>
              </div>
            </div>

        </div>

        <div class="row mx-lg-n5 mt-5">

        </div>

      </div>
    </Layout>
  )
}